import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRubygemsComponent } from './simple-icons-rubygems.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRubygemsComponent ],
    exports:      [ SimpleIconsRubygemsComponent ],
    bootstrap:    []
})
export class SimpleIconsRubygemsModule {}
